<div class="title">
  <h1 class="product-heading-bold">Currency Exchange Rates</h1>
</div>
<span class="data-heading"
  >Manage your exchange rates for converting your {{ 'scope.p|l' | lang }} to a different currency than the base
  currency</span
>
<div class="flex flex-row justify-end items-center gap-2 h-12">
  <button
    class="action-button"
    (click)="addExchangeRate()"
    mat-button>
    <mat-icon class="material-symbols-rounded">add</mat-icon>Add Exchange Rate
  </button>
</div>
<mat-divider></mat-divider>
<scope-ui-table
  class="block mt-1"
  [loading]="loading"
  [tableClass]="'overview-table'"
  [loggedInUser]="loggedInUser"
  [data]="exchangeRates"
  [displayedColumns]="columns"
  [addToggleListColumn]="true"
  [totalCount]="tableData?.totalCount"
  [page]="tableData?.page"
  [noPreferences]="true"
  [menuOptions]="menuOptions"
  [expandable]="true"
  [rowGaps]="true"
  [condensed]="true"
  [noSort]="true"
  [pageSize]="pageSize"
  [selectMode]="ScopeUiTableSelectMode.NAME"
  (pageChange)="onChangePage($event)"
  (onSelect)="editExchangeRate($event)">
  <ng-template let-element>
    <scope-ui-table
      class="w-full"
      tableClass="nested"
      [isSubTable]="true"
      [condensed]="true"
      [loggedInUser]="loggedInUser"
      [unmappedData]="element.children"
      [displayedColumns]="versionHistoryColumns"
      [noPreferences]="true"
      [noPagination]="true"
      [noSort]="true"
      [addToggleListColumn]="true"
      [showToggleMenu]="false">
    </scope-ui-table>
  </ng-template>
</scope-ui-table>
